import { render, staticRenderFns } from "./sp-people-group-modal.vue?vue&type=template&id=65005c4c&scoped=true"
import script from "./sp-people-group-modal.vue?vue&type=script&lang=js"
export * from "./sp-people-group-modal.vue?vue&type=script&lang=js"
import style0 from "./sp-people-group-modal.vue?vue&type=style&index=0&id=65005c4c&prod&lang=scss"
import style1 from "./sp-people-group-modal.vue?vue&type=style&index=1&id=65005c4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65005c4c",
  null
  
)

export default component.exports